import { Box } from '@chakra-ui/react'
import styled from '@emotion/styled'

interface ICircleCustom {
    size: number
}

export const CircleCustom = styled(Box)<ICircleCustom>`
    display: flex;
    justify-content: center;
    align-items: center;

    border-radius: 50%;

    width: ${props => `${props.size}px`};
    height: ${props => `${props.size}px`};
`
